'use client';
import { useParams } from 'next/navigation';
import React, { useState } from 'react';
import AddressRequiredNotice from '../address-required-notice';
import SoloMealItemList from '../solo-meal-item-list';
import SolomealCategory from './solomeal-category';
import { useCityLocation } from '@/hooks/use-city-location';
import { useAiFoodOrderStore } from '@/store/use-ai-store';

export default function SolomealContainer() {
  const params = useParams();
  const storeCitySlug = useAiFoodOrderStore.use.city_slug();
  const storeCityName = useAiFoodOrderStore.use.city_name();
  const [selectedCategory, setSelectedCategory] = useState<
    string | undefined
  >();

  const citySlug = Array.isArray(params.city) ? params.city[0] : params.city;

  // SoloMeal xếp món theo khoảng cách nên BẮT BUỘC toạ độ thật, và toạ độ phải
  // thuộc đúng city đang xem. `useCityLocation` lo cả hai, kể cả ca route
  // rootless `/solomeal` (không có segment city → dùng luôn địa chỉ).
  //
  // Trước đây chỗ này fallback về toạ độ Hồ Chí Minh cứng (10.762622,
  // 106.660172): user ở Đà Nẵng chưa nhập địa chỉ sẽ được gợi ý món quanh Bến
  // Thành mà không hề biết. Thà không hiển thị còn hơn hiển thị sai.
  const { lat, lng, hasLocation } = useCityLocation();

  return (
    <div className="min-h-screen bg-neutral-5" data-testid="solomeal-screen">
      <SolomealCategory
        selectedCategory={selectedCategory}
        onCategoryChange={setSelectedCategory}
      />

      {hasLocation ? (
        <SoloMealItemList lat={lat!} lng={lng!} category={selectedCategory} />
      ) : (
        <AddressRequiredNotice
          cityName={
            !citySlug || storeCitySlug === citySlug
              ? (storeCityName ?? undefined)
              : undefined
          }
          variant="page"
        />
      )}
    </div>
  );
}
